<div class="d-flex flex-row align-content-center">
  <span *ngIf="showExclamation">
    <i class="bi bi-exclamation-lg text-danger fs-3"></i>
  </span>
  {{ dateValue }}
</div>
